import { StyledLogo } from '@/components/styles'
import { ActiveLink } from '@/components'
import { useTranslation } from 'react-i18next'
import { localizePath } from '@/lib/locales'

export default function Logo({ theme = 'default', ...props }) {
  const { i18n } = useTranslation('global')
  const homeAs = localizePath('/', i18n.language)
  return (
    <ActiveLink href="/" as={homeAs}>
      <StyledLogo theme={theme}>
        <picture>
          <source type="image/webp" srcset="/images/logo.webp" />
          <img src="/images/logo.jpeg" alt="ELEMENTAL Day Surgical Center" height={54} width={237}/>
        </picture>
      </StyledLogo>
    </ActiveLink>
  )
}
